var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSucess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.384 10.067L20.317 19L19.433 19.8839L10.5 10.9509L1.56699 19.8839L0.683044 19L9.61607 10.067L0.683046 1.13394L1.56699 0.25L10.5 9.18303L19.433 0.25L20.317 1.13394L11.384 10.067Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSucess);
export default __webpack_public_path__ + "static/media/CloseSucess.9d539d1a62b124a70ba8749c5143215c.svg";
export { ForwardRef as ReactComponent };